import { Card, Col, Form, Input, InputNumber, Layout, Row, Switch } from 'antd';
import { includes, toNumber } from 'lodash';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FormActionButton from 'src/components/common/FormActionButton';
import { messages } from 'src/constants/messages';
import { apiCaller, cancelListToken } from 'src/util/apiCaller';
import { MessageStatusError } from 'src/util/MessageStatus';

const FormItem = Form.Item;

const initialState = {
  tenHanLuuTru: "",
  isVinhVien: false,
  soNam: 0,
  isSuDung: true
};

const ThoiHanLuuTruForm = ({ status }: any) => {
  const { isActive } = status;
  const navigate = useNavigate();
  const [fieldTouch, setFieldTouch] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingButtonClose, setLoadingButtonClose] = useState(false);
  const [form] = Form.useForm();
  const { tenHanLuuTru, isVinhVien, isSuDung, soNam } = initialState;
  const [type, setType] = useState("new");
  const { id } = useParams();
  const location = useLocation();

  const { validateFields, resetFields, setFieldsValue } = form;

  useEffect(() => {
    if (isActive) {
      const load = () => {
        if (includes(location.pathname, "them-moi")) {
          setType("new");
        } else {
          setType("edit");
          getInfo();
        }
      };
      load();
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["infothoihanluutru"]);
    };
  }, []);

  /**
   * getInfo : Lấy thông tin
   * @memberof  HanLuuTruForm
   */
  const getInfo = async () => {
    if (location.state && location.state.itemData) {
      // Nếu có dữ liệu truyền sang
      const res = location.state.itemData;
      setFieldsValue({
        hanluutru: res
      });
    } else {
      const configAPI = {
        url: `api/hanluutru/${id}`,
        method: "GET",
        value: "",
        apiType: "DETAIL",
        getName: "infothoihanluutru"
      };
      const response = await apiCaller(configAPI);
      try {
        if (
          response?.data &&
          (response.status === 200 || response.status === 201)
        ) {
          setFieldsValue({
            hanluutru: response.data
          });
        } else {
          MessageStatusError(toNumber(response?.status));
        }
      } catch (error) {
        // Xử lý lỗi khi lưu dữ liệu không thành công
      }
    }
  };

  /**
   * goBack : quay lại trang danh sách
   * @memberof  HanLuuTruForm
   */
  const goBack = () => {
    navigate("/quan-tri/thoi-han-luu-tru");
  };

  /**
   * save : lưu dữu liệu
   * @memberof  HanLuuTruForm
   */
  const save = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        saveData(values, false);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveAndClose: Lưu và đóng
   * @memberof HanLuuTruForm
   */
  const saveAndClose = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        saveData(values, true);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveData : lưu dữu liệu
   * @memberof  HanLuuTruForm
   */
  const saveData = async (values: any, saveQuit = false) => {
    try {
      let configAPI;
      if (type === "new") {
        configAPI = {
          url: `api/hanluutru/create`,
          method: "POST",
          data: values.hanluutru,
          apiType: "ADD",
          isShowMessage: true
        };
      } else {
        const data = values.hanluutru;
        data.id = Number(id);
        configAPI = {
          url: `api/HanLuuTru/${id}`,
          method: "PUT",
          data: data,
          apiType: "EDIT",
          isShowMessage: true
        };
      }

      const response = await apiCaller(configAPI);
      if (response?.status === 200 || response?.status === 201) {
        if (saveQuit) {
          goBack();
          setLoadingButtonClose(false);
        } else {
          if (type === "new") {
            resetFields();
          }
          setFieldTouch(false);
          setLoadingButton(false);
        }
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingButton(false);
      }
    } catch (error) {
      setLoadingButton(false);
    }
  };

  return (
    <Layout>
      <div style={{ display: "flex" }}>
        <Col md={12}>
          <h2 style={{ color: "black", fontSize: 20, marginTop: 10 }}>
            {type === "new"
              ? "Thêm mới thời hạn lưu trữ"
              : "Chỉnh sửa thời hạn lưu trữ"}
          </h2>
        </Col>
      </div>
      <Card>
        <Form
          className="form-container wrapper-content-inner"
          layout="vertical"
          form={form}
          name="hanluutru-control"
          onFieldsChange={() => setFieldTouch(true)}
        >
          <Row gutter={24}>
            <Col md={8} xs={24}>
              <FormItem
                layout="vertical"
                label={<span>Tên hạn lưu trữ</span>}
                name={["hanluutru", "tenHanLuuTru"]}
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: messages.ERROR_REQUIRED
                  }
                ]}
                initialValue={tenHanLuuTru}
              >
                <Input
                  name="tenHanLuuTru"
                  className="input-item"
                  placeholder="Nhập tên hạn lưu trữ"
                />
              </FormItem>
            </Col>
            <Col md={8} xs={24}>
              <FormItem
                label={<span>Số năm</span>}
                name={["hanluutru", "soNam"]}
                initialValue={soNam}
              >
                <InputNumber style={{width : "100%"}} name="soNam" className="input-item" min={0} />
              </FormItem>
            </Col>
            <Col md={4} xs={12}>
              <FormItem
                label="Vĩnh viễn"
                name={["hanluutru", "isVinhVien"]}
                valuePropName="checked"
                initialValue={isVinhVien}
              >
                <Switch />
              </FormItem>
            </Col>
            <Col md={4} xs={12}>
              <FormItem
                label="Sử dụng"
                name={["hanluutru", "isSuDung"]}
                valuePropName="checked"
                initialValue={isSuDung}
              >
                <Switch />
              </FormItem>
            </Col>
          </Row>
          <hr />
          <FormActionButton
            goBack={goBack}
            saveAndClose={saveAndClose}
            disabled={fieldTouch}
            save={save}
            loadingButton={loadingButton}
            loadingButtonClose={loadingButtonClose}
          />
        </Form>
      </Card>
    </Layout>
  );
};

export default ThoiHanLuuTruForm;
